import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import AdminHeader from './AdminHeader';
import { logout, setSessionLanguage } from "../../parts/session/sessionActions";
import { fetchUnreadNumber } from "../../messages/messageActions";

const mapStateToProps = state => ({
  user: state.session.user,
  userType: state.session.userType,
  locale: state.session.language,
  platform: state.platform.platform,
  isEditingForm: state.ui.isEditingForm,
  unreadNumber: state.message.unreadNumber,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  logout,
  setSessionLanguage,
  fetchUnreadNumber
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AdminHeader);
